import {
  buttonSizeMedium,
  variantContainedPrimaryClasses,
} from 'libs/shared/ui/src/lib/components/button/styles'

export const cssClassesForSurvey = Object.freeze({
  root: 'sr-root',
  body: 'sr-body',
  page: {
    root: '',
  },
  bodyNavigationButton: 'sr-btn',
  question: {
    header: 'sr-question-header',
    title: 'sr-question-title',
    content: 'sr-question-content',
  },
  radiogroup: {
    root: 'sr-radiogroup-root',
    rootRow: 'sr-radiogroup-row',
    column: '',
    label: 'sr-radio-box',
    controlLabel: '',
    item: '',
  },
  panel: {
    header: 'sr-panel-header',
    content: 'sd-panel__content',
    titleExpandable: '',
    titleExpanded: 'sr-element__title--expanded sr-element__title',
    titleCollapsed: 'sr-element__title--collapsed sr-element__title',
  },
  text: {
    root: 'sr-text-input',
  },
  actionBar: {
    root: 'sd-action-bar justify-center mt-8 relative',
  },
  navigation: {
    complete: `${variantContainedPrimaryClasses} ${buttonSizeMedium} rounded cursor-pointer`,
  },
})
